import type { FunctionComponent } from "react";
import { useEffect } from "react";

import {
  useInitializeScmpLoginFormWithEventHandlers,
  useLoginDialogStateHelper,
} from "scmp-app/components/login-dialog/hooks";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import { Container, LoginForm, Tnc } from "./styles";

export const PlusLoginWall: FunctionComponent = () => {
  const { setLoginDialogState } = useLoginDialogStateHelper();
  const { reference } = useInitializeScmpLoginFormWithEventHandlers();

  useEffect(() => {
    setLoginDialogState({
      application: "scmp-plus",
      description: "",
      destination: `${window.location.origin}/plus`,
      emailLoginTitle: "Log in / Sign up",
      isVisible: true,
      title: "Already a Plus subscriber?",
      variant: "inline",
    });
    sendGA4Tracking({
      action: "imp",
      category: "login",
      customized_parameters: {
        paywall_type: "plus_wall",
        product: "plus",
        trigger_point: "paywall",
      },
      subcategory: "popup",
    });
  }, [setLoginDialogState]);

  return (
    <Container>
      <LoginForm>
        <div id="loginContainer" ref={reference} />
      </LoginForm>
      <Tnc>
        By creating an account, you agree to our{" "}
        <a href="/terms-conditions" rel="noreferrer" target="_blank">
          Terms of Service
        </a>{" "}
        and acknowledge our{" "}
        <a href="/privacy-policy" rel="noreferrer" target="_blank">
          Privacy Policy
        </a>
        .
      </Tnc>
    </Container>
  );
};

PlusLoginWall.displayName = "PlusLoginWall";
